export default __webpack_public_path__ + "static/media/ic_norfolk_island.138c6b61.svg";